import { createAction, props } from '@ngrx/store';
export const setSavedAnalysisPlanId = createAction('[Custom PDF Report Modal] Set Saved Analysis Plan ID', props());
